<template>
  <div id="statistical">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'statistical'
}
</script>




// WEBPACK FOOTER //
// src/views/contract/statistical/Statistical.vue